function normalizeSearchString(value: unknown): string | undefined {
  if (typeof value !== 'string') {
    return undefined;
  }

  const normalized = value.trim().toLowerCase();
  return normalized.length > 0 ? normalized : undefined;
}

export function parsePositiveIntegerSearchValue(value: unknown): number | undefined {
  if (typeof value === 'number') {
    return Number.isInteger(value) && value > 0 ? value : undefined;
  }

  const normalized = normalizeSearchString(value);
  if (!normalized || !/^\d+$/.test(normalized)) {
    return undefined;
  }

  const parsed = Number(normalized);
  return parsed > 0 ? parsed : undefined;
}
